import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import { Card, CardBody, CardTitleWrap, CardTitle, CardSubhead } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditSubscription = (props) => {
    const [subscription, setSubscription] = useState();

    const GetSubscription = (subscription_id) => {
        AdminInterface.instance.getSubscription(subscription_id).then((response) => {
            response.data.no_users = response.data.users.length;
            response.data.expiry_datetime = response.data.expiry_datetime?.slice(0, 10);
            setSubscription(response.data);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    }

    useEffect(() => {
        if (props.subscription_id){
            GetSubscription(props.subscription_id);
        }
    }, [props.subscription_id]);

    const submitOrganizationUpdates = (subscription) => {
        subscription.expiry_datetime = new Date(subscription.expiry_datetime + 'T00:00:00')
        AdminInterface.instance.updateSubscription(props.subscription_id, subscription).then(() => {
            Swal.fire('Updated!', '', 'success')
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    }

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Edit Subscription</CardTitle>
                    </CardTitleWrap>
                    <Form onSubmit={submitOrganizationUpdates} initialValues={subscription}>
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit} disabled>
                                <FormGroup>
                                    <FormGroupLabel>Organization Id</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="organization_id" component="input" type="text" placeholder="Id" disabled />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Organization Name</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="organization.display_name" component="input" type="text" placeholder="Name" disabled />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Subscription Plan</FormGroupLabel>
                                    <FormGroupField vertical={1}>
                                        <Field
                                            name="subscription"
                                            component={renderRadioButtonField}
                                            label="Freemium"
                                            radioValue="Freemium"
                                        />
                                        <Field
                                            name="subscription"
                                            component={renderRadioButtonField}
                                            label="Starter"
                                            radioValue="Starter"
                                        />
                                        <Field
                                            name="subscription"
                                            component={renderRadioButtonField}
                                            label="Professional"
                                            radioValue="Professional"
                                        />
                                        <Field
                                            name="subscription"
                                            component={renderRadioButtonField}
                                            label="Enterprise"
                                            radioValue="Enterprise"
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Expiry Date</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="expiry_datetime" component="input" type="date" placeholder="Expiry Date" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Number of members</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="no_users" component="input" type="text" placeholder="Number of Members" disabled />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit" disabled={!props.subscription_id}>Submit</Button>
                                    <Button variant="secondary" type="button" disabled={!props.subscription_id} onClick={() => {
                                        props.setEditOrganizationIdHandler(null);
                                    }}>Cancel</Button>
                                </FormButtonToolbar>
                            </FormContainer>)}
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default EditSubscription;